import * as React from 'react';

const TgIcon = () => {
	return (
		<svg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				d='M3.10549 16.3918L7.97919 18.1279C8.98595 18.4865 10.1108 18.3602 11.0042 17.7882L21.3895 11.1396C21.625 10.9888 21.9386 11.0187 22.1387 11.2109C22.377 11.4397 22.3694 11.8129 22.1222 12.0327L14.4367 18.8628C13.9987 19.2522 14.033 19.927 14.5083 20.2736L22.6254 26.1904C24.0884 27.2569 26.2068 26.435 26.488 24.692L29.3129 7.17469C29.512 5.94023 28.2228 4.97527 27.0248 5.462L3.07727 15.1914C2.82851 15.2926 2.66675 15.5268 2.66675 15.7862C2.66675 16.0564 2.84173 16.2979 3.10549 16.3918Z'
				fill='#BBB5AA'
			/>
		</svg>
	);
};
export default TgIcon;
